import { CircularProgress } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import icon from 'src/assets/images/appointment-view-calander-icon.png';
import httpRequest from 'src/helpers/httpRequest';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
interface IProps {
    bool: boolean;
    appointmentId: string;
};
interface IObj {
    _id: string;
    appointmentId: string;
    title: string;
    comment: string;
    dateAdded: string;
    createdAt: string;
    updatedAt: string;
    user?: string;
    cancelBy?: string;
    [key: string]: any;
};

const HomecareAppointmentHistories: React.FC<IProps> = ({
    bool = false,
    appointmentId = "",
}) => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [data, setData] = useState<IObj[]>([]);

    const fetch = async () => {
        setIsLoader(true);
        const { res, err } = await httpRequest<IObj[]>({ path: `/home-care-order/appointment/get/history/${appointmentId}` });
        if (res) {
            setData(res || []);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };
    useEffect(() => {
        if (appointmentId) {
            fetch();
        }
    }, [bool, appointmentId]);
    return (
        <>
            {isLoader ?
                <div className="text-center mt-5">
                    <CircularProgress size={20} style={{ color: "#004540" }} />
                </div>
                : data?.length ?
                    data.map((item: IObj, index: number) => (
                        <div key={index} className="pt-6 w-[100%]">
                            <div className="flex items-center justify-center">
                                <p className="font-Poppins-SemiBold font-size-15px theme-color-green">
                                    {moment(item?.createdAt).format("ddd D MMM")}
                                </p>
                            </div>
                            <div className="grid grid-cols-[.5fr_9.5fr] gap-[20px] mt-2">
                                <div className='relative z-10 flex items-center justify-center'>
                                    {index < data?.length - 1 && (
                                        <div className="absolute top-[23%] left-[50%] translate-x-[-50%] w-[5px] h-[140%] bg-[#00443F]"></div>
                                    )}
                                    <div className="flex items-center justify-center rounded-full bg-[#00443F] self-start w-[40px] h-[40px] mt-3 relative z-20">
                                        <img src={icon} alt="calander-icon" />
                                    </div>
                                </div>
                                <div className='p-4 border-[2px] border-[#00443F] rounded-[13px] '>
                                    <div className="flex gap-2 items-center justify-between">
                                        <div>
                                            <p className="font-Poppins-SemiBold font-size-15px capitalize">
                                                {item?.user || item?.cancelBy || ""}
                                            </p>
                                            <p className="font-Poppins-SemiBold font-size-15px">
                                                {item?.title || ""}
                                            </p>
                                        </div>

                                        <div className='flex gap-2 items-center'>
                                            <p className="font-Poppins-Regular font-size-15px ml-1">
                                                {moment(item?.createdAt).format("h:mm A")}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="my-1">
                                        {item?.rating &&
                                            <div className="stars flex gap-1 items-center mb-1">
                                                {[1, 2, 3, 4, 5].map((v) => (
                                                    <FontAwesomeIcon
                                                        className={item?.rating >= v ? "text-[#facc15]" : `text-[#b7b6b1]`}
                                                        key={v}
                                                        role="button"
                                                        fontSize="16px"
                                                        icon={faStar}
                                                    />
                                                ))}
                                            </div>
                                        }
                                        <p className="font-Poppins-Regular font-size-15px">
                                            {item?.comment || ""}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                    :
                    <div>
                        <p className="font-Poppins-Medium font-size-16px my-4 text-center">No History</p>
                    </div>
            }
        </>
    );
};

export default HomecareAppointmentHistories;